<div class="withdraw-unavailable">
	<div class="withdraw-unavailable-content">
		<div class="withdraw-unavailable-headline">{{ "please_first_make_deposit" | translate }}</div>
		<div class="withdraw-unavailable-description">{{ "make_deposit_description" | translate: [fiatName] }}</div>
		<div class="withdraw-unavailable-buttons-container">
			<button class="btn btn-primary withdraw-unavailable-button" (click)="deposit()">
				{{ "deposit_now" | translate }}
			</button>
		</div>
	</div>
</div>
